import { dayjs } from "@thalamos/common";
export const validateSection2ExaminationDate = (date) => date
    ? dayjs().diff(date, "days") > 20
        ? "The selected date is more than 20 days in the past. This is normally too far in the past for this medical recommendation to be valid for an application. Please check you have entered the correct date."
        : null
    : null;
//# sourceMappingURL=section2.js.map